import { Operation } from '../../Transactions.types';
import { OperationDetailsContent } from '../OperationDetailsContent';
import { Modal } from '@/components/UI/Modal/Modal';

interface OperationDetailsModalProps {
  operation: Operation | null;
  onClose: () => void;
}

export function OperationDetailsModal({
  operation,
  onClose,
}: OperationDetailsModalProps) {
  if (!operation) {
    return null;
  }

  return (
    <Modal isOpen onClose={onClose} maxWidth={540} borderRadius={21} isInPortal>
      <OperationDetailsContent operation={operation} onClose={onClose} />
    </Modal>
  );
}
